const en = {
  // 404 ERROR PAGE
  errorTitle: 'Page Not Found.',
  errorSubTitle: 'Sorry, the page you`re looking for doesn`t exist.',
  errorMsg1: 'Try going back to the previous page',
  errorMsg2: 'If you think something is broken, report a problem',
  errorMsg3: '',
  back: 'GO BACK',

  // LOGIN
  id: 'ID',
  pw: 'Password',
  login: 'LOGIN',
  autoLogin: 'Auto Login',

  // 공통 
  no: 'No',
  search: 'Search',
  inquery: 'Search',
  excel: 'Excel Download',
  plus: 'Add',
  save: 'Save',
  delete: 'Delete',
  print: 'Print',
  close: 'Close',
  cancel: 'Cancel',
  confirm: 'Confirm',
  reload: 'Reload',
  camera: 'Camera',
  apply: 'Apply',
  copy: 'Copy',
  themeGenerator: 'Theme Generator',
  themeSelect: 'Theme Select',
  color: 'Color',
  button: 'Button',
  radio: 'Radio',
  checkBox: 'CheckBox',
  selectBox: 'SelectBox',
  input: 'Input',
  dialog: 'Dialog',
  data: 'Data',
  graph: 'Graph',
  period: 'Period',
  use: 'use',
  unused: 'unused',
  correction: 'correction',
  initialization: 'Initialization',

  // COMPONENTS
  icardHorizontal: 'i-Card Horizontal',
  icardVertical: 'i-Card Vertical',
  idataTable: 'i-Data Table',
  iseleltList: 'i-Selelt List',
  idialog: 'i-Dialog',

  // 메뉴

  // baseInfoManage: 'Base Management',
  dashboard: 'Dashboard',
  // monitoring: 'Monitoring',
  // dataSearch: 'DataSearch',
  // setting: 'Setting',

  // equipmentInfoManage: 'Equipment Management',
  // collectionItemManage: 'Tag Management',
  // userManage: 'User  Management',
  // alarmManage: 'Alarm Management',

  // Base Information

  //card Title
  commonCodeTitle: '■ Common Code',
  commonCodeDetail: '■ Common Code Detail',
  companyInfoTitle: '■ Company Info',
  departmentInfo: '■ Department Info',
  factoryInfoTitle: '■ Factory Info',
  processInfoTitle: '■ Process Info',
  warehouseInfoTitle: '■ Warehouse Info',
  warehouseLocInfoTitle: '■ Warehouse Location Info',
  workStationInfo: '■ Work Station Info',
  workGroupInfo: '■ Work Group Info',
  equipmentInfo: '■ Equipment Info',
  pathInfo: '■ Path Info',
  customer: '■ Customer',
  employeeInfo: '■ Employee Info',
  customerInfo: '■ Customer Info',
  itemSelection: '■ Item Selection',
  itemInfoTitle: '■ Item Info',
  pathTypeTitle: '■ Path Type',
  routeInfoTitle: '■ Route Info',
  bomInfoTitle: '■ BOM Info',
  customerInfoByItemTitle: '■ Customer Info By Item',
  unitPriceInfoTitle: '■ unit Price Info',
  inspectionType:'■ Inspection Type',
  inspectionItems :'■ Inspection Items',

  //Data Column
  inspection:'Inspection Type',
  appStartDate: 'AppStartDate',
  appEndDate: 'AppEndDate',
  modiYN: 'ModiYn',
  partSpec: 'PartSpec',
  comName: 'Company Name',
  corNumber: 'Corporate Reg Number',
  comNumber: 'Company Reg Number',
  name: 'Representative Name',
  postNo: 'Zip Code',
  addr: 'Address',
  tel: 'Phone Number',
  fax: 'Fax Number',
  codegr: 'Code group',
  code: 'Code',
  codeName: 'CodeName',
  sysCode: 'SysCode',
  sysName: 'SysName',
  prtCode: 'Parent Code',

  depCode: 'Department Code',
  depName: 'Department',
  padeCode: 'Upper department Code',
  paDecodeNm: 'Upper department',

  userId: 'User ID',
  userName: 'User Name',
  perCode: 'Permission Group Code',
  typeCode: 'Employee Type Code',
  typeCodeNm: 'Employee Type',
  posiCode: 'Position Code',
  posiCodeNm: 'Position',
  hp: 'Hp',
  email: 'Email',
  entDate: 'Date Of Entry',
  lanCode: 'Language Code',
  userImage: 'User Image',

  custCode: 'Customer Code',
  custName: 'Customer Name',
  custType: 'Account Type Code',
  custTypeNm: 'Account Type',
  matType: 'Transaction Type Code',
  matTypeNm: 'Transaction Type',
  conType: 'Business Status',
  secType: 'Sectors',
  manName: 'Manager Name',
  manTel: 'Manager Phone',
  manAddr: 'Manager Email',

  partNo: 'Part Number',
  partName: 'Product Name',
  spec: 'spec',

  itemType: 'Item Type',
  partType: 'Part Type',
  suite: 'Suite',
  unit: 'Unit',
  inWh: 'In Warehouse',
  outWh: 'Out Warehouse',
  lotSize: 'Lot Size',
  safeCnt: 'Safety Stock',
  insName:'Inspection Type Name',
  inInsp: 'Incoming Inspection',
  proInsp: 'Process Inspection',
  rotInsp: 'Circuit Inspection',
  outInsp: 'Shipment Inspection',
  lastInsp: 'Final Check',
  supInsp: 'Supplier outgoing Inspection ',
  leadTime: 'Lead Time(days)',
  weightYn: 'Single Use Or Not',
  weight: 'Single Weight(kg)',
  userDef1: 'Custom1',
  userDef2: 'Custom2',
  userDef3: 'Custom3',

  pathType: 'Path Type Code',
  pathTypeName: 'Path Type Name',
  pathCode: 'Route Code',
  inWhcode: 'In Warehouse Code',
  inWhcodeName: 'In Warehouse Name',
  sortFlag: 'Sort Order',

  pathNo: 'Process Order',
  proCode: 'process Code',
  matCost: 'Material Cost',
  proCost: 'Processing Cost',
  labCost: 'Labor Cost',

  level: 'Level',
  paPartNo: 'Parents No',
  No: 'no',
  childPartNo: 'Part Number Code',

  amount: 'Exhaustion',

  appDate: 'Effective Date',
  appYN: 'Unit Price Applied',
  price: 'Unit Price',

  currDate: 'Date',
  currCode: 'Currency Code',
  price2: 'Base Exchange Rate',

  facCode: 'Factory Code',
  facName: 'Factory Name',
  facNumber: 'Factory Number',
  facRepName: 'Factory Rep Name',

  proName: 'Process Name',
  proType: 'Process Type',
  //*catType: '공정유형 코드',

  whCode: 'Warehouse code',
  whName: 'Warehouse Name',
  whType: 'Warehouse Type',
  whDesc: 'Warehouse Description',
  locCode: 'Location code',
  locName: 'Location Name',

  workCode: 'Work Station Code',
  workName: 'Work Station Name',
  workType: 'Work Station Type',
  workDesc: 'Work Station Description',
  workDecode: 'WorkGroup Code',
  workDename: 'WorkGroup Name',
  workDedesc: 'WorkGroup Description',
  perWh: 'Performance Process Code',

  eqCode: 'equipment Code',
  eqName: 'equipment Name',
  eqSpec: 'equipment Spec',
  eqGrade: 'equipment Grade',
  eqState: 'equipment State(equipment Group)',
  //*makeCode: '설비상태 코드',
  makeCom: 'Make Company',
  //*perCom: '구입회사',
  proDate: 'produce Date',
  insDate: 'Install Date',
  desDate: 'disuse Date',
  eqpImage: 'Equipment Image',

  pathName: 'Path Name',
  procCode: 'Process Code',
  procNo: 'Process No.',

  insCode: 'Test Type Code',
  insType: 'Test Category Code',
  insMeth: 'Measure Method Code',
  jugCodeh: 'Judgment Method Code',

  inspNo: 'Check Sequence',
  insUnit: 'Check Unit Code',
  insBase: 'Check Criterion',
  insUpp: 'Upper Limit',
  insLow: 'Lower Limit',
  insCnt: 'Sample Count',

  whCode_autoInput: 'automatic Input Warehose Code',
  proCode_facGrp: 'process Code(facility Group)',
  nowWhCode: 'Current Warehouse Code',


  //tab name
  departmentInfoTab: 'Department Info',
  customerInfoTab: 'Customer Info',

  //popup
  addCustomerInfo: 'Add Customer Information',
  registrantInfo: 'Registrant Information',

  //production Management

  // sales Management

  //card Title
  shptReg: '■ Shipment Registration',
  shptChk: '■ Shipment Check',
  returnReg: '■ Return Registration',
  salesCfm: '■ Sales Confirmation',

  //Data Column
  ordNo: 'Order No',
  ilNo: 'Serial Number',
  outDate: 'Out DAte',
  lotNo: 'Shipment Lot',
  lotDetail: 'Shipment Computational No', //출하 전산 번호
  qty: 'Qty',
  closeMonth: 'Close Month',
  closeYn: 'Close Yn',
  confirmYn: 'Confirm Yn',
  sampleQty1: 'Sample Qty1',
  sampleQty2: 'Sample Qty2',
  sampleQty3: 'Sample Qty3',
  sampleQty4: 'Sample Qty4',
  sampleQty5: 'Sample Qty5',
  retLotNo: 'Return LOT',
  retLotDetail: 'Return Computational No', //반품전산번호
  retCode: 'Return Sortation Code', //반품구분코드
  retType: 'Return Reasons for defect', //반품불량사유
  retQty: 'Return Qty',


  // System Management

  //Add Message
  sys0010AddCheck: 'Please enter the Menu Code and Module Code.',
  sys0020AddCheck: 'Please enter the Permission Group (Code).',

  //card title
  permissionGroupInfo: 'Permission Group Info',
  menuList: 'Menu List',

  //Data Column
  comCode: 'Company Code',
  //proCode: 'Plant Code',
  sysType: 'System Type',
  menuCode: 'Menu Code',
  moduleCode: 'Module Code',
  moduleName: 'Module Name',
  menuName: 'Menu Name',
  paCode: 'Parents Menu Code',
  pgCode: 'Program Code',
  icon: 'Icon',
  remark: 'Remark',
  userFlag: 'User Flag',
  makeDate: 'Make Date',
  maker: 'Maker',
  editDate: 'Edit Date',
  editor: 'Editor',

  perName: 'Authority Group Name',

  permissionGroup: 'Permission Group (Code)',

  //card title(Material Management, 자재관리)

  purchOrdInfo: '■ Purchase Order Information',
  purchOrdInfoDetail: '■ Purchase Order Information Details',
  purchWarinReg: '■ Purchase Warehousing Registration',
  purchWarinRegDetail: '■ Purchase Warehousing Registration Details',
  otr_PvtSupWarinReg: '■ Other/Private Supply Warehousing Registration',
  otr_PvtSupWarinDetail: '■ Other/Private Supply Warehousing Details',
  matlReqt: '■ Material Requirement (Based on production plan)',
  matlReqtDetail: '■ Material Requirement Details',
  manualOperReg: '■ Manual Operation Registration',
  excelReg: '■ Excel Registration',




  //Data Column
  ordState: 'Order State',
  deliDate: 'Delivery Date',
  stockQty: 'Stock Qty',
  inQty: 'In Qty',
  remQty: 'Residual Quantity',

  makeQty: 'Make Qty',
  boxQty: 'Box Qty',
  inPrice: 'In Price',
  inAmount: 'In Amount',
  printType: 'Print Type',
  ilNo_serNo: 'Warehousing No(Serial No)',
  //ilNo:'일련번호', (보류)
  serialNo: 'Serial Number Order',
  status: 'Warehousing State',
  fromDate: 'Calculation Start Date',
  toDate: 'Calculation End Date',
  currQty: 'Current Inventory Quantity',
  expQty: 'Unreceived Quantity',
  reqQty: 'Exhaustion Quantity',
  lackQty: 'Shortage Quantity',
  ordQty: 'Order Quantity',
  ordAppYn: 'Material Order Application Status',

  realQty: 'Actual Quantity',
  realState: 'Actual State',
  stockType: 'Inventory Type',
  regiType: 'Registration Type',


  // Dashboard
  // themeTab: 'Theme',
  // controlsTab: 'Controls',
  // gridTab: 'Grid',
  // chartsTab: 'Charts',
  // componentsTab: 'Components', 

  // Monitoring
  // equipmentSelect: 'Equipment select',
  // weldingData: 'Welding data',
  // statusInfo: 'Status information',
  // weldingImage: 'Welding image',
  // current: 'current',
  // voltage: 'voltage',
  // gas: 'gas',
  // feeding: 'feeding',

  // Setting
  // baseGroup: 'Base group',
  // baseCode: 'Base code',
  // userGroup: 'User group',
  // userList: 'User list',

  // Data Search
  // equipmentInfomation: 'Equipment infomation',

  // MSG
  // enableCheckbox: 'Activate/deactivate through a check box.',

  //Common Message
  SelectCheck: 'No data is selected.',
  doSaveData: 'Do you want to save?',
  doFixData: 'Do you want to fix it?',
  Saved: 'Saved.',
  changed: 'It is changed.',
  doDeleteData: 'do you want to delete?',
  deleted: 'Deleted.',
  requiredCheck:'Please enter a required item.',
  //부서정보,사원정보,거래처정보 Message
  requiredInput: 'Enter the company code and department code.',
  requiredInput2: 'Enter your company code, department code, and user ID.',
  requiredInput3: 'Please enter your company code and account code.',
  departmentCodeOverlap: 'Duplicate department code.',
  userIdOverlap: 'Duplicate user ID.',
  accountCodeOverlap: 'The account code is duplicated.',
  employeesRegistered: 'There are employees registered in the department.',
  resetYourPassword: 'Are you sure you want to reset your password?',
  resetPassword: 'Your password has been reset.',
  departmentsSelected: 'There are no departments selected.',

  //공장/창고/작업장/경로정보 Message
  bas0120PleaseCheck1: 'Please select factory information.',
  bas0120PleaseCheck2: 'Please select warehouse information.',
  bas0120PleaseCheck3: 'Please select workshop information.',
  bas0120PleaseCheck4: 'Please select path information.',
  bas0120NotFound1: 'Warehouse code does not exist.',
  bas0120NotFound2: 'Workshop code does not exist.',
  bas0120NotFound3: 'Path code does not exist.',

  bas0120RequiredInput1: 'Enter the company code and factory code',
  bas0120RequiredInput2: 'Enter process code',
  bas0120RequiredInput3: 'Enter warehouse code',
  bas0120RequiredInput4: 'Enter warehouse code and location code',
  bas0120RequiredInput5: 'Enter workshop code',
  bas0120RequiredInput6: 'Enter workshop code and workgroup code',
  bas0120RequiredInput7: 'Enter facility code',
  bas0120RequiredInput8: 'Enter path code',
  bas0120RequiredInput9: 'Enter the path code process code and process No',

  // POP Title
  itemInfo: 'Item Infomation',
  mainItem: 'Main Item'

}
export default en